import { Button, Form, Input, Select, message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import {
  CallBackConfigPayload,
  getCallBackSourceServiceConfigs,
  saveCallbackServiceSourceConfig,
  getSourceAppNames,
  MstRequest,
  SourceAppNamelist,
  getCallBackServiceNames,
  CallBackServicelist,
} from 'api/master';

//import { Modal } from 'antd';
import { FileExcelFilled } from '@ant-design/icons';

import Callbacklist from '../Callbacklist';
import xlsx from 'json-as-xlsx';
import moment from 'moment';

//const filterPayload: CallBackConfigPayload = {};
const mstRequest: MstRequest = {};

const Filter = () => {
  const { Option } = Select;
  const [form] = Form.useForm<CallBackConfigPayload>();
  const [filter, setFilter] = useState(mstRequest);
  const [sourceAppNames, setSourceAppNames] = useState<SourceAppNamelist[]>([]);
  const [callbackserviceNames, setCallbackServiceNames] = useState<CallBackServicelist[]>([]);
  const isAdmin = sessionStorage.getItem('isAdmin');
  useEffect(() => {
    fetchSourceAppNames();
  }, []);

  const fetchSourceAppNames = async () => {
    try {
      debugger;
      mstRequest.userName = sessionStorage.getItem('user')?.toString();
      mstRequest.isActive = true;
      mstRequest.pageNo = 0;
      mstRequest.pageSize = 0;
      mstRequest.roleId = '';
      const response = await getSourceAppNames(mstRequest);
      console.log('Source application names:', response.data);
      setSourceAppNames(response.data);
      const res = await getCallBackServiceNames(mstRequest);
      console.log('CallBackService names:', res.data);
      setCallbackServiceNames(res.data);
    } catch (error) {
      console.error('Error fetching source application names:', error); // Log any errors
    }
  };

  const handleSubmit = useCallback(
    async (values: CallBackConfigPayload) => {
      try {
        debugger;
        const concatenatedValue = `{"${values.key}":"${values.value}"}`;
        values.headers = concatenatedValue;
        values.createdBy = sessionStorage.getItem('user')?.toString();
        values.flag = true;
        values.sourceName = '';
        values.createdOn = '';
        await saveCallbackServiceSourceConfig(values);
        form.resetFields();
        setFilter({});
        // Modal.success({
        //     title: 'Success',
        //     content: 'Configuration saved successfully.',
        //     onOk: () => window.location.reload(),
        // });
        message.success('Configuration saved successfully.');
        window.location.reload();
      } catch (error) {
        console.error('Error saving configuration:', error);
        message.error('Failed to save configuration. Please try again.');
      }
    },
    [form]
  );

  function getFullDate(date: string, format = 'DD/MM/YYYY HH:mm:ss') {
    if (date != null) {
      const dateMoment = moment(new Date(date)).format(format);
      return dateMoment;
    }
  }

  function handleDownload(_e: any) {
    debugger;
    filter.pageNo = -1;
    filter.isExtract = true;
    // getCallBackSourceServiceConfigs(filter).then((_x) => {
    //     const csvConfig = {
    //         useKeysAsHeaders: true,
    //         filename: 'Callback -Report.csv'
    //     };
    //     const csvData = generateCsv(csvConfig)(_x.data.data);
    //     download(csvConfig)(csvData);
    // });
    getCallBackSourceServiceConfigs(filter).then((_x) => {
      console.log('service source mapping ', _x);
      let settings = {
        fileName: 'Callback -Report',
        extraLength: 3,
        writeMode: 'writeFile',
        writeOptions: {},
        RTL: false,
      };

      const sortedData =
        _x.data?.data.sort((a: any, b: any) => {
          return b.id - a.id;
        }) || [];
      const updatedData = sortedData.map((item: any, index) => ({
        ...item,
        createdOn: getFullDate(item.createdOn),
        ROWNUM: index + 1,
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'id', value: 'id' },
            { label: 'Service Name', value: 'serviceName' },
            { label: 'Callback URL', value: 'callbackURL' },
            { label: 'Headers', value: 'headers' },
            { label: 'Flag', value: 'flag' },
            { label: 'Created By', value: 'createdBy' },
            { label: 'Created On', value: 'createdOn' },
            { label: 'Source Name', value: 'sourceName' },
            { label: 'Display Name', value: 'displayName' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Callback Configuration Master</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<CallBackConfigPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    ['sourceName']:
                      isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Source Application Name:'}
                          name="sourceId"
                          className="fieldTitle"
                          rules={[
                            { required: true, message: 'Please select source application name.' },
                          ]}
                        >
                          <Select placeholder="Select" size="large">
                            {sourceAppNames.map((app) => (
                              <Option key={app.sourceId} value={app.sourceId}>
                                {app.sourceApplicationName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Callback Service'}
                          name="serviceName"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please select callback service.' }]}
                        >
                          <Select placeholder="Select" size="large">
                            {callbackserviceNames.map((app) => (
                              <Option key={app.serviceName} value={app.serviceName}>
                                {app.displayName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Callback URL '}
                          name="callbackURL"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please enter callback url.' }]}
                        >
                          <Input placeholder={'CallbackURL'} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div>
                      <label
                        htmlFor=""
                        className="fieldTitle"
                        style={{ fontWeight: 'bold', fontSize: 'larger' }}
                      >
                        Header:
                      </label>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Key '}
                          name="key"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please enter key.' }]}
                        >
                          <Input placeholder={'Key'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Value '}
                          name="value"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please enter Value.' }]}
                        >
                          <Input placeholder={'Value'} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* <div className="col-xs-12 col-sm-4 col-md-4">
                                            <div className="input-box">
                                                <Form.Item label={'Callback URL '} name="callbackURL" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter callback url.' }]}
                                                >
                                                    <Input placeholder={'CallbackURL'} />
                                                </Form.Item>
                                            </div>
                                        </div> */}
                  </div>
                  <div className="row">
                    <div className="payment-button">
                      <Button
                        className="proceed-btn"
                        id="btnClear"
                        size="small"
                        style={{ height: '40px', width: '100px' }}
                        onClick={() => form.resetFields()}
                      >
                        CLEAR
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        id="btnSave"
                        className="proceed-btn"
                        size="small"
                        style={{ height: '40px', width: '100px', marginBottom: '10px' }}
                        onClick={() => form.submit()}
                      >
                        SAVE
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        type="link"
                        icon={<FileExcelFilled />}
                        style={{ float: 'right', fontSize: '30px', color: 'green' }}
                        onClick={handleDownload}
                      ></Button>
                    </div>
                  </div>
                </Form>
              </div>
              <Callbacklist filter={{ ...filter }} onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
